import "../global/jQuerySetting";
require.context('./imgs', true, /.*/); //copy whole imgs folder

import "./scss/styles.scss";

import "bootstrap";
import "nette.ajax.js";
import "nette-forms";
import "@fancyapps/fancybox/dist/jquery.fancybox";
import "justifiedGallery/src/js/justifiedGallery";
import "../others/nette-ajax/spinner";
// import "./js/cookiesConfirm"; //uncomment to use + set analytics
import "../others/sandbox/js/theme";
import "./js/payment";
import "./js/inits";

window.Nette = require('nette-forms');
Nette.initOnLoad();
